import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "submenu-wrapper"
}
const _hoisted_2 = { class: "user-info" }
const _hoisted_3 = {
  key: 0,
  class: "submenu-wrapper"
}
const _hoisted_4 = ["disabled"]
const _hoisted_5 = ["href"]
const _hoisted_6 = {
  key: 0,
  class: "submenu-wrapper"
}
const _hoisted_7 = {
  key: 0,
  class: "submenu-wrapper"
}
const _hoisted_8 = { class: "new-project-form modal-form" }
const _hoisted_9 = { class: "modal-form-main" }
const _hoisted_10 = { class: "section-sub" }
const _hoisted_11 = { class: "section-sub" }
const _hoisted_12 = { class: "modal-form-buttons" }
const _hoisted_13 = { class: "new-band-form modal-form" }
const _hoisted_14 = { class: "modal-form-main" }
const _hoisted_15 = { class: "section-sub" }
const _hoisted_16 = { class: "modal-form-buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_sub_menu_item = _resolveComponent("sub-menu-item")!
  const _component_sub_menu = _resolveComponent("sub-menu")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_confirm = _resolveComponent("confirm")!
  const _component_bands_autocomplete = _resolveComponent("bands-autocomplete")!
  const _component_modal = _resolveComponent("modal")!
  const _component_bounce_modal = _resolveComponent("bounce-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("ul", {
      ref: "mainmenu",
      onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.onMenuClick && _ctx.onMenuClick(...args))),
      class: "mainmenu"
    }, [
      _createElementVNode("li", {
        onMouseover: _cache[1] || (_cache[1] = ($event: any) => (_ctx.menu = 'eavesdrop')),
        class: "mainmenu-item"
      }, [
        _cache[29] || (_cache[29] = _createElementVNode("b", null, "Eavesdrop", -1)),
        (_ctx.menuOpened && _ctx.menu === 'eavesdrop')
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(_component_sub_menu, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", {
                      class: "user-avatar",
                      style: _normalizeStyle({ backgroundImage: `url(${_ctx.user.avatar_url})` })
                    }, null, 4),
                    _createElementVNode("div", null, _toDisplayString(_ctx.user.first_name) + " " + _toDisplayString(_ctx.user.last_name), 1)
                  ]),
                  _cache[28] || (_cache[28] = _createElementVNode("hr", null, null, -1)),
                  _createVNode(_component_sub_menu_item, null, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)), ["prevent","stop"])),
                        href: "#"
                      }, "Logout...")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ], 32),
      (_ctx.$route.meta.section === 'mix')
        ? (_openBlock(), _createElementBlock("li", {
            key: 0,
            onMouseover: _cache[7] || (_cache[7] = ($event: any) => (_ctx.menu = 'mixes')),
            class: "mainmenu-item"
          }, [
            _cache[31] || (_cache[31] = _createTextVNode(" Mix ", -1)),
            (_ctx.menuOpened && _ctx.menu === 'mixes')
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createVNode(_component_sub_menu, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_sub_menu_item, null, {
                        default: _withCtx(() => [
                          _createElementVNode("a", {
                            href: "#",
                            disabled: !_ctx.mixPropsDirty,
                            onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.saveMix && _ctx.saveMix(...args)), ["prevent","stop"]))
                          }, " Save ", 8, _hoisted_4)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_sub_menu_item, null, {
                        default: _withCtx(() => [
                          _createElementVNode("a", {
                            href: "#",
                            onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.createMix && _ctx.createMix(...args)), ["prevent","stop"]))
                          }, " New mix ")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_sub_menu_item, null, {
                        default: _withCtx(() => [
                          _createElementVNode("a", {
                            href: "#",
                            onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.cloneConfirm = true), ["prevent","stop"]))
                          }, " Clone... ")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_sub_menu_item, null, {
                        default: _withCtx(() => [
                          _createElementVNode("a", {
                            href: "#",
                            onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.deleteConfirm = true), ["prevent","stop"]))
                          }, " Delete... ")
                        ]),
                        _: 1
                      }),
                      _cache[30] || (_cache[30] = _createElementVNode("hr", null, null, -1)),
                      (_ctx.stemsLink !== '')
                        ? (_openBlock(), _createBlock(_component_sub_menu_item, { key: 0 }, {
                            default: _withCtx(() => [
                              _createElementVNode("a", {
                                href: _ctx.stemsLink,
                                target: "_blank"
                              }, " Download Stems ", 8, _hoisted_5)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_sub_menu_item, null, {
                        default: _withCtx(() => [
                          _createElementVNode("a", {
                            href: "#",
                            onClick: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openBounceForm && _ctx.openBounceForm(...args)), ["prevent","stop"]))
                          }, " Bounce Mix ")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ], 32))
        : _createCommentVNode("", true),
      _createElementVNode("li", {
        onMouseover: _cache[11] || (_cache[11] = ($event: any) => (_ctx.menu = 'projects')),
        class: "mainmenu-item"
      }, [
        _cache[34] || (_cache[34] = _createTextVNode(" Project ", -1)),
        (_ctx.menuOpened && _ctx.menu === 'projects')
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_sub_menu, null, {
                default: _withCtx(() => [
                  _createVNode(_component_sub_menu_item, null, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        onClick: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openNewProjectForm && _ctx.openNewProjectForm(...args)), ["prevent","stop"])),
                        href: "#"
                      }, " Create new... ")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_sub_menu_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_router_link, {
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.menuOpened = false)),
                        to: "/projects"
                      }, {
                        default: _withCtx(() => [...(_cache[32] || (_cache[32] = [
                          _createTextVNode(" Project Manager ", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _cache[33] || (_cache[33] = _createElementVNode("hr", null, null, -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projectsSlice, (project) => {
                    return (_openBlock(), _createBlock(_component_sub_menu_item, {
                      key: project._id
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_router_link, {
                          onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.menuOpened = false)),
                          to: `/projects/${project._id}`
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(project.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ], 32),
      _createElementVNode("li", {
        onMouseover: _cache[14] || (_cache[14] = ($event: any) => (_ctx.menu = 'bands')),
        class: "mainmenu-item"
      }, [
        _cache[36] || (_cache[36] = _createTextVNode(" Band ", -1)),
        (_ctx.menuOpened && _ctx.menu === 'bands')
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(_component_sub_menu, null, {
                default: _withCtx(() => [
                  _createVNode(_component_sub_menu_item, null, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        href: "#",
                        onClick: _cache[12] || (_cache[12] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openNewBandForm && _ctx.openNewBandForm(...args)), ["prevent","stop"]))
                      }, " Create new... ")
                    ]),
                    _: 1
                  }),
                  _cache[35] || (_cache[35] = _createElementVNode("hr", null, null, -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bands, (band) => {
                    return (_openBlock(), _createBlock(_component_sub_menu_item, {
                      key: band._id
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_router_link, {
                          onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.menuOpened = false)),
                          to: `/bands/${band._id}`
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(band.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ], 32)
    ], 512),
    (_ctx.cloneConfirm)
      ? (_openBlock(), _createBlock(_component_confirm, {
          key: 0,
          title: "Clone Mix",
          onOk: _ctx.cloneMix,
          onOpen: _cache[16] || (_cache[16] = ($event: any) => (_ctx.menuOpened = false)),
          onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.cloneConfirm = false))
        }, null, 8, ["onOk"]))
      : _createCommentVNode("", true),
    (_ctx.deleteConfirm)
      ? (_openBlock(), _createBlock(_component_confirm, {
          key: 1,
          title: "Delete Mix",
          onOk: _ctx.deleteMix,
          onOpen: _cache[18] || (_cache[18] = ($event: any) => (_ctx.menuOpened = false)),
          onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.deleteConfirm = false))
        }, null, 8, ["onOk"]))
      : _createCommentVNode("", true),
    (_ctx.newProjectForm)
      ? (_openBlock(), _createBlock(_component_modal, { key: 2 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, [
              _cache[39] || (_cache[39] = _createElementVNode("div", { class: "modal-form-header" }, "Create New Project", -1)),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _cache[37] || (_cache[37] = _createElementVNode("label", null, "Name", -1)),
                  _withDirectives(_createElementVNode("input", {
                    ref: "projectNameInput",
                    class: "input",
                    type: "text",
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.projectName) = $event)),
                    placeholder: "Project Name"
                  }, null, 512), [
                    [_vModelText, _ctx.projectName]
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _cache[38] || (_cache[38] = _createElementVNode("label", null, "Band", -1)),
                  _createVNode(_component_bands_autocomplete, {
                    onPick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.projectBand = $event))
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("button", {
                  onClick: _cache[22] || (_cache[22] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.createProject && _ctx.createProject(...args)), ["prevent","stop"])),
                  class: "btn-outline"
                }, " Create "),
                _createElementVNode("button", {
                  onClick: _cache[23] || (_cache[23] = _withModifiers(($event: any) => (_ctx.newProjectForm = false), ["prevent","stop"])),
                  class: "btn-outline"
                }, " Cancel ")
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.newBandForm)
      ? (_openBlock(), _createBlock(_component_modal, { key: 3 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_13, [
              _cache[41] || (_cache[41] = _createElementVNode("div", { class: "modal-form-header" }, "Create New Band", -1)),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _cache[40] || (_cache[40] = _createElementVNode("label", null, "Name", -1)),
                  _withDirectives(_createElementVNode("input", {
                    ref: "bandNameInput",
                    class: "input",
                    type: "text",
                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.bandName) = $event)),
                    placeholder: "Band Name"
                  }, null, 512), [
                    [_vModelText, _ctx.bandName]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("button", {
                  onClick: _cache[25] || (_cache[25] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.createBand && _ctx.createBand(...args)), ["prevent","stop"])),
                  class: "btn-outline"
                }, " Create "),
                _createElementVNode("button", {
                  onClick: _cache[26] || (_cache[26] = _withModifiers(($event: any) => (_ctx.newBandForm = false), ["prevent","stop"])),
                  class: "btn-outline"
                }, " Cancel ")
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.bounceForm)
      ? (_openBlock(), _createBlock(_component_bounce_modal, {
          key: 4,
          onClose: _cache[27] || (_cache[27] = ($event: any) => (_ctx.bounceForm = false))
        }))
      : _createCommentVNode("", true)
  ], 64))
}